module.exports = __webpack_public_path__ + "img/OG.80d34409.png";